import {Component, ElementRef, Inject, Input, NgZone, Renderer2, ViewEncapsulation, DOCUMENT, ChangeDetectionStrategy} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AsyncTranslationLoader} from '../../app/async-translation-loader';
import {StateService} from '../../app/services/state.service';
import {ApiService} from '../../app/services/api.service';

import {ActivatedRoute, Router} from '@angular/router';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {TranslateService} from '@ngx-translate/core';
import {CoolLocalStorage} from '@angular-cool/storage';
import {FieldErrorService} from '../../app/services/field-error.service';
import {AnalyticsService} from '../../app/services/analytics.service';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {VisitorService} from '../../app/services/visitor.service';
import {LANGUAGES} from '../../app/data/languages';
import {CustomerService} from "../../app/services/customer.service";
import {InlineWebbookerComponent} from "../inline-webbooker/inline-webbooker.component";
import {MatIconRegistry} from "@angular/material/icon";

const apiFormIdProvider = (state: StateService, route: ActivatedRoute) => {
  if (route.parent && route.parent.snapshot) {
    return route.parent.snapshot.params.formId;
  } else {
    return state.formId;
  }
};

interface Styles {
  colors: any;
}

declare global {
  interface Window {
    initMyOrder(arg:string, arg1: number);
  }
}

@Component({
    selector: 'app-widget',
    templateUrl: '../../app/form/order/order.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./popup-widget.component.scss',
        '../../app/form/order/order.component.scss'],
    providers: [
        {
            provide: 'apiModel',
            useValue: 'orders'
        },
        {
            provide: 'apiFormId',
            useFactory: apiFormIdProvider,
            deps: [StateService, ActivatedRoute]
        },
        ApiService, CustomerService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupWidgetComponent extends InlineWebbookerComponent {
  formStyle = 'widget';
  @Input() formid: string;
  @Input() language: string;
  navigation = 'modal';
  @Input() buttonbgcolor: string = '#000000';
  @Input() buttontextcolor: string = '#ffffff' ;
  @Input() buttontext: string = 'process_order_button';
  @Input() buttonposition: string = 'topRight';
  @Input() buttonstyle: string = 'rounded';
  @Input() widgettype: string = 'popup-widget';
  @Input() origin: string = 'floating-widget'; // Override parent default

  @Input() showtopbar: boolean = true;
  @Input() showbreadcrumbs: boolean = true;
  @Input() showlogo: boolean = true;
  @Input() showclose: boolean = true;
  @Input() headercolor: string = '#000000';
  @Input() textcolor: string = '#000000';
  @Input() backgroundcolor: string = '#FFFFFF';

  constructor(private zone: NgZone,
              iconRegistry: MatIconRegistry,
              sanitizer: DomSanitizer,
              http: HttpClient,
              activatedRoute: ActivatedRoute,
              apiService: ApiService,
              modalService: NgxSmartModalService,
              translate: TranslateService,
              vault: CoolLocalStorage,
              router: Router,
              route: ActivatedRoute,
              state: StateService,
              errorService: FieldErrorService,
              analytics: AnalyticsService,
              pageTitle: Title,
              visitorService: VisitorService,
              _customerService: CustomerService,
              _renderer2: Renderer2,
              _iconRegistry: MatIconRegistry,
              _sanitizer: DomSanitizer,
              @Inject('Window') window: Window,
              @Inject(DOCUMENT) document: Document,
              hostEl: ElementRef) {
    super(http, iconRegistry, sanitizer, activatedRoute, apiService, modalService, translate, vault, router, route,
      state, errorService, analytics, pageTitle, visitorService, _customerService, _renderer2, _iconRegistry, _sanitizer, window, document, hostEl);

    const availableLanguages = [];
    Object.keys(LANGUAGES).forEach(key => {
      availableLanguages.push(LANGUAGES[key]);
    });
    // Add available languages
    translate.addLangs(availableLanguages);
    state.translationId$.subscribe(id => {
      if (id !== '') {
        AsyncTranslationLoader.translationIdSubject.next(id);
      }
    });

    this.loadAssets();

    this.isWidget = true;
    this.nState = state;
    this.nTranslate = translate;
    this.nModalService = modalService;
    this.nActivatedRoute = activatedRoute;
    this.nRouter = router;
    this.nVault = vault;

    window.initMyOrder = () => {
      // Since this function runs outside Angular's zone, we need to get back inside!
      this.zone.run(() => {
        document.documentElement.style.setProperty('--wb-modal-top', '50px');
        this.navigate('next', 0);
      });
    }
  }
}
